module.exports = __webpack_public_path__ + "static/homeBGMobile.5e884f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homeBGMobile.jpg
// module id = 840
// module chunks = 35783957827783